/**------------------------------------------------------
 * RxJs Schedule
 * -------------
 * ...
 */
export class RxJsSchedule {
	// ...
}
